export default __webpack_public_path__ + "static/media/bi.0c879e8c.jpg";